// db/cleanStatus.js

import {
  dbPromise,
  STATUS_STORE,
} from "./fsDB";

/* =========================================================
   STATUS CLEANUP
   Removes expired/deleted statuses from IndexedDB
   and notifies React.
========================================================= */

const CLEANUP_INTERVAL_MS =
  60 * 1000; // every minute

let cleanupTimer = null;

/* =========================================================
   CLEANUP PASS
========================================================= */

async function cleanupStatuses() {

  try {

    const db =
      await dbPromise;

    const tx =
      db.transaction(
        STATUS_STORE,
        "readwrite"
      );

    const store =
      tx.objectStore(
        STATUS_STORE
      );

    const statuses =
      await store.getAll();

    const now =
      Date.now();

    const removedIds = [];

    for (const status of statuses) {

      const expiresAt =
        new Date(
          status.expiresAt
        ).getTime();

      const expired =

        status.isDeleted ||

        !expiresAt ||

        expiresAt <= now;

      if (!expired) {

        continue;

      }

      await store.delete(
        status.statusId
      );

      removedIds.push(
        status.statusId
      );

    }

    await tx.done;

    if (removedIds.length) {

      window.dispatchEvent(

        new CustomEvent(

          "status:expired",

          {

            detail: {

              statusIds:
                removedIds,

            },

          }

        )

      );

    }

  }

  catch (err) {


  }

}

/* =========================================================
   START
========================================================= */

export function startStatusCleanup() {

  if (cleanupTimer) {

    return;

  }
  // Run immediately

  cleanupStatuses();

  cleanupTimer =
    setInterval(

      cleanupStatuses,

      CLEANUP_INTERVAL_MS

    );

}

/* =========================================================
   STOP
========================================================= */

export function stopStatusCleanup() {

  if (!cleanupTimer) {

    return;

  }

  clearInterval(
    cleanupTimer
  );

  cleanupTimer =
    null;

}